import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Thumbnail from '@components/@core/Thumbnail';
import { htmlHasImage } from '~/services/util';

const Card = ({ avatar, user, date, title, owner, thumbnail, description, iframe, special = '', onClick }) => (
    <div className="blog-card card" onClick={onClick}>
        <p className="dsl-b22 bold">{special}</p>
        <div className="d-h-between">
            <div className="d-flex ai-center">
                <Avatar className="mr-2" url={avatar} isSponsored={true} />
                <div>
                    <p className="dsl-m12 mb-1">{`${user?.first_name} ${user?.last_name}`}</p>
                    <p className="dsl-b12 mb-0">{owner}</p>
                </div>
            </div>
            <span className="dsl-m12">{date}</span>
        </div>
        <p className="dsl-b16 bold mt-4">{title}</p>
        {iframe ? (
            <div className="blog-iframe" dangerouslySetInnerHTML={{ __html: iframe }} />
        ) : htmlHasImage(thumbnail) ? (
            <div className="blog-image d-flex jc-center mb-3" dangerouslySetInnerHTML={{ __html: thumbnail }} />
        ) : (
            <Thumbnail size="responsive" />
        )}
        <p className="dsl-b16 m-0">
            {description ? `${description.substring(0, 200)}...` : ''}
            <Button name="Read more" type="link" />
        </p>
    </div>
);

Card.propTypes = {
    avatar: PropTypes.string,
    user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        profile: PropTypes.shape({ company: PropTypes.string }),
    }),
    date: PropTypes.string,
    title: PropTypes.string,
    owner: PropTypes.string,
    thumbnail: PropTypes.string,
    description: PropTypes.string,
    iframe: PropTypes.string,
    onClick: PropTypes.func,
};

Card.defaultProps = {
    avatar: '',
    user: { first_name: '', last_name: '', profile: { company: '' } },
    date: '',
    title: '',
    owner: '',
    thumbnail: '',
    description: '',
    iframe: '',
    onClick: () => {},
};

export default Card;
